export function isValidUrl(urlString: string): boolean {
  if (typeof urlString !== 'string') {
    return false;
  }

  try {
    new URL(urlString);
    return true;
  } catch (error: unknown) {
    return false;
  }
}
